import React from 'react';
import { Box, Typography } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

interface UpliftBadgeProps {
  uplift: number;
  ciLow: number;
  ciHigh: number;
  size?: 'small' | 'medium';
}

const UpliftBadge: React.FC<UpliftBadgeProps> = ({ uplift, ciLow, ciHigh, size = 'medium' }) => {
  const isPositive = uplift > 0;
  const isSignificant = (ciLow > 0 && ciHigh > 0) || (ciLow < 0 && ciHigh < 0);
  
  const backgroundColor = isPositive 
    ? isSignificant ? '#e8f5e9' : '#f1f8e9'
    : isSignificant ? '#ffebee' : '#fef5e7';
  
  const textColor = isPositive 
    ? isSignificant ? '#2e7d32' : '#558b2f'
    : isSignificant ? '#c62828' : '#e65100';

  const fontSize = size === 'small' ? '12px' : '14px';
  const padding = size === 'small' ? '4px 8px' : '6px 10px';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        backgroundColor,
        color: textColor,
        padding,
        borderRadius: 1,
        fontSize,
        fontWeight: 600,
      }}
    >
      {isPositive ? <TrendingUp fontSize="inherit" /> : <TrendingDown fontSize="inherit" />}
      <span>{isPositive ? '+' : ''}{uplift.toFixed(1)}%</span>
      <Typography variant="caption" sx={{ color: 'inherit', opacity: 0.7 }}>
        [{ciLow.toFixed(1)}, {ciHigh.toFixed(1)}]
      </Typography>
    </Box>
  );
};

export default UpliftBadge;
